class SearchTime

  disableClass: 'is-disable'
  activeClass: 'is-active'

  constructor: (@$elm, @$days, @$area) ->
    @$timeBox  = $ '.js-date-time-box'
    @$timeList = @$timeBox.find 'li'
    @$modal    = $ '[data-remodal-id=remodal-time]'
    @$title    = @$modal.find '.js-time-title'
    @modal     = @$modal.remodal()
    @$elm.on 'click', @open
    @$timeList.on 'click', @select

  open: (event) =>
    @timeElm = event.currentTarget
    nameTime = @timeElm.name.replace '_time', ''
    $day     = @$days.filter "[name^=#{nameTime}]"
    dayValue = $day.val().replace /-/g, '/'
    value    = @timeElm.value
    date     = new Date "#{dayValue} #{value}"
    dateTime = date.getTime()
    if @timeElm.name.indexOf('go') isnt -1
      disableTime = window.baseTime.getTime()
      titleText = '出発時刻'
    else
      disableTime = window.startTime.getTime() + 1
      titleText = '返却時刻'

    _.forEach @$timeList, (elm) =>
      elm.classList.remove @activeClass
      elm.classList.remove @disableClass
      _time = elm.textContent
      _day  = new Date "#{dayValue} #{_time}"
      _time = _day.getTime()
      if disableTime > _time
        elm.classList.add @disableClass
      if dateTime is _time
        elm.classList.add @activeClass

    @$title.text titleText
    @modal.open()

  select: (event) =>
    elm = event.currentTarget
    return true if elm.classList.contains 'is-disable'
    @$timeList.removeClass @activeClass
    elm.classList.add @activeClass
    @timeElm.value = @dateTextFormat elm.textContent
    setTime = elm.textContent.split ':'

    if @timeElm.name.indexOf('go') isnt -1
      window.startTime.setHours setTime[0]
      window.startTime.setMinutes setTime[1]
      @mergeTime()
    else
      window.endTime.setHours setTime[0]
      window.endTime.setMinutes setTime[1]
    @modal.close()

    # 自動送り
    if @timeElm.name.indexOf('go') isnt -1
      if window.searchStory.length < 2
        setTimeout =>
          window.searchStory.push true
          @$elm.last().trigger 'click'
        , 400
    else
      if window.searchStory.length < 3
        setTimeout =>
          window.searchStory.push true
          @$area.first().trigger 'click'
        , 400

  init: =>
    _.forEach @$elm, (elm) =>
      elm.value = if elm.name.indexOf('go') isnt -1
        @dateTimeFormat window.startTime
      else
        @dateTimeFormat window.endTime

  dateTextFormat: (text) ->
    time = text.split ':'
    hh = if time[0] < 10 then "0#{time[0]}" else time[0]
    mm = time[1]
    "#{hh}:#{mm}"

  dateTimeFormat: (date) ->
    hh = date.getHours()
    mm = date.getMinutes()
    hh = if hh < 10 then "0#{hh}" else hh
    mm = if mm < 10 then "0#{mm}" else mm
    "#{hh}:#{mm}"

  mergeTime: =>
    start = window.startTime.getTime()
    end   = window.endTime.getTime()
    if start >= end
      window.endTime.setHours window.startTime.getHours()
      window.endTime.setMinutes window.startTime.getMinutes() + 30
      @$elm
        .filter '[name^=return]'
        .val @dateTimeFormat window.endTime

  debugDate: (date) ->
    year  = date.getFullYear()
    month = date.getMonth() + 1
    day   = date.getDate()
    "#{year}/#{month}/#{day}"

export default SearchTime



// WEBPACK FOOTER //
// ./webpack/imports/view/search-time.coffee